// tslint:disable:no-any
import React, { Component } from 'react';

export interface IDivesFilterRowProps {
    active: boolean;
    year?: number;
    onClick: (y: number) => void;
}

class DivesFilterRow extends Component<IDivesFilterRowProps> {
    render() {
        return (
            <div
                className={
                    'sidebarMenu__item' + (this.props.active ? ' current' : '')
                }
                onClick={() => this.props.onClick((!this.props.year ? null : this.props.year) as any)}
            >
                {!this.props.year ? 'All' : this.props.year}
            </div>
        );
    }
}

export interface IDivesFilterYearsProps {
    dives: any;
    onYearSet: (y: number) => void;
}

interface IDivesFilterYearState {
    dives: any;
    current: any;
    years: any;
}

class DivesFilterYears extends Component<
    IDivesFilterYearsProps,
    IDivesFilterYearState
> {
    constructor(props: IDivesFilterYearsProps) {
        super(props);

        this.state = {
            current: null,
            dives: props.dives,
            years: []
        };
    }

    componentDidMount() {
        var newYears: any = [];
        this.state.dives.forEach((dive: any) => {
            var date = new Date(dive.startDate);
            var year = date.getFullYear();
            if (newYears.indexOf(year) === -1) {
                newYears.push(year);
            }
        });

        newYears.sort((a: any, b: any) => {
            return a < b ? 1 : -1;
        });

        this.setState({
            years: newYears
        });
    }

    handleSetCurrent(year: number) {
        this.setState({
            current: year
        });

        this.props.onYearSet(year);
    }

    render() {
        var rows: any = [];
        this.state.years.forEach((year: any, index: number) => {
            rows.push(
                <DivesFilterRow
                    key={index}
                    year={year}
                    active={this.state.current === year}
                    onClick={e => this.handleSetCurrent(e)}
                />
            );
        });

        return (
            <div className="sidebarMenu sidebar__filterYears">
                <DivesFilterRow
                    year={undefined}
                    active={this.state.current === null}
                    onClick={e => this.handleSetCurrent(e)}
                />
                {rows}
            </div>
        );
    }
}

export default DivesFilterYears;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DivesFilterYears.tsx